import { Image, Shape, Slide, Table, TableCellProps, Text } from "react-pptx";
import {
  BaseLineTableCell,
  BaseLineTableCellHeader,
} from "./BaseLineTableCell";
import {
  JSXElementConstructor,
  ReactElement,
  useEffect,
  useState,
} from "react";
import { OverallActivityResult } from "../../../../types/overallActivityResult";
import { useTranslation } from "react-i18next";
import { IndustryBenchMarkRowType } from "../../../Reuseables/DashboardComponents/OverallIndustryResultsTable";

type OverviewPowerpoint = {
  numOfEmployees: number;
  numOfActivityLogs: number;
  numOfPainReports: number;
  compliance: number;
  activities: OverallActivityResult[];
  translate: any;
  activitySlides: ReactElement<any, string | JSXElementConstructor<any>>[];
  benchmarkSlides: ReactElement<any, string | JSXElementConstructor<any>>[];
};

export const OverviewPowerpoint: React.FC<OverviewPowerpoint> = ({
  numOfEmployees,
  numOfActivityLogs,
  numOfPainReports,
  compliance,
  activities,
  translate,
  activitySlides,
  benchmarkSlides,
}) => {
  const leftMargin = 0.25;
  const slideBackgroundColor = "#F9F5F1";
  const precureGreen = "#5BBFAC";

  

  const GenerateErgonomicTable = () => {
    const list: (
      | string
      | ReactElement<TableCellProps, string | JSXElementConstructor<any>>
    )[][] = [];
    list.push([...BaseLineTableCellHeader()]);

    var activityList = [...activities]
      .sort(
        (a, b) =>
          (b.activityData.average?.mli ?? 0) -
          (a.activityData.average?.mli ?? 0)
      )
      .slice(0, 5);

    activityList?.map((x: OverallActivityResult, i: number) => {
      //  if (x. == null) return;

      let backgroundColor = "#ECEFF3";
      if (i % 2 == 0) {
        backgroundColor = "#CBD1D8";
      }
      list.push([
        ...BaseLineTableCell({
          translate: translate,
          overallActivity: x,
          backgroundColor,
        }),
      ]);
    });
    return list;
  }; // Construct Table Cells

  return (
    <>
      <Slide
        style={{
          backgroundImage: {
            kind: "path",
            path: "https://corsproxy.io/?url=https://precure-cdn.azureedge.net/images/Background.png",
          },
        }}
      >
        <Image
          src={{
            kind: "path",
            path: "https://corsproxy.io/?url=https://precure-cdn.azureedge.net/images/Precure_logo_RGB_Hvide_Bogstaver.svg",
          }}
          style={{ x: "17%", y: "30%", h: 1, w: 5 }}
        />
        <Text
          style={{
            fontSize: 10,
            italic: true,
            x: "50%",
            y: "45%",
            h: 0.5,
            w: 2.2,
            color: "#FFFFFF",
          }}
        >
          Help prevent work-related musculoskeletal disorders
        </Text>
      </Slide>
      <Slide style={{ backgroundColor: slideBackgroundColor }}>
        <Text
          style={{ x: leftMargin, y: 0.25, w: "50%", h: 0.3, fontSize: 20 }}
        >
          Welcome to PRECURE
        </Text>
        <Text style={{ x: leftMargin, y: 0.6, w: "50%", h: 0.3, fontSize: 16 }}>
          Introduction
        </Text>
        <Shape
          type="rect"
          style={{
            backgroundColor: precureGreen,
            borderColor: precureGreen,
            x: leftMargin,
            y: 1,
            h: 0.02,
            w: "40%",
          }}
        />
        <Text
          style={{ x: leftMargin, y: 1.5, w: "50%", h: "20%", fontSize: 11 }}
        >
          Thank you for your cooperation and your commitment to improving the
          work environment for your employees. When employees experience high
          levels of pain or significant ergonomic risk, the impact on your
          business can be substantial and multifaceted. This report helps
          identify high-risk functions, pinpoint key risk factors, and suggest
          strategies for mitigation. If you have conducted an effect
          measurement, the report will also show how the interventions have
          influenced risk and pain levels - providing clear ROI calculations.​
        </Text>

        <Text
          style={{
            x: leftMargin,
            y: 3,
            bold: true,
            fontSize: 15,
            h: 0.3,
            w: 2,
          }}
        >
          Content
        </Text>
        <Text
          style={{
            x: leftMargin,
            y: 4,
            fontSize: 11,
            h: 0.3,
            w: 3,
          }}
        >
          <Text.Bullet type="number">Baseline Data</Text.Bullet>
          <Text.Bullet type="number">Results</Text.Bullet>
          <Text.Bullet type="number">Designed Interventions</Text.Bullet>
          <Text.Bullet type="number">Effect</Text.Bullet>
          <Text.Bullet type="number">ROI</Text.Bullet>
          <Text.Bullet type="number">Risk Financing</Text.Bullet>
        </Text>
        <Image
          src={{
            kind: "path",
            path: "https://corsproxy.io/?url=https://precure-cdn.azureedge.net/images/IMG_3665-removebg.png",
          }}
          style={{ x: "55%", y: 0, h: "100%", w: "45%" }}
        />
        <Shape
          type="rect"
          style={{
            backgroundColor: precureGreen,
            borderColor: precureGreen,
            x: "20%",
            y: "95%",
            h: 0.02,
            w: "40%",
          }}
        />
      </Slide>
      <Slide style={{ backgroundColor: slideBackgroundColor }}>
        <Text
          style={{ x: leftMargin, y: 0.25, w: "50%", h: 0.3, fontSize: 20 }}
        >
          Baseline Data
        </Text>
        <Text style={{ x: leftMargin, y: 0.6, w: "50%", h: 0.3, fontSize: 16 }}>
          Customized Pilot
        </Text>
        <Shape
          type="rect"
          style={{
            backgroundColor: precureGreen,
            borderColor: precureGreen,
            x: leftMargin,
            y: 1,
            h: 0.02,
            w: "40%",
          }}
        />
        {/* Numbers of users */}
        <BaselineData
          xMargin={leftMargin}
          y={1.5}
          title="Employees:"
          value={numOfEmployees.toString()}
          src="https://corsproxy.io/?url=https://precure-cdn.azureedge.net/images/people.svg"
        />
        <BaselineData
          xMargin={leftMargin + 2.7}
          y={1.5}
          title="Activity Reports:"
          value={numOfActivityLogs.toString()}
          src="https://corsproxy.io/?url=https://precure-cdn.azureedge.net/images/sickleave.svg"
        />
        <BaselineData
          xMargin={leftMargin}
          y={2.5}
          title="Compliance:"
          value={compliance.toString() + "%"}
          src="https://corsproxy.io/?url=https://precure-cdn.azureedge.net/images/people.svg"
        />
        <BaselineData
          xMargin={leftMargin + 2.7}
          y={2.5}
          title="Pain Reports:"
          value={numOfPainReports.toString()}
          src="https://corsproxy.io/?url=https://precure-cdn.azureedge.net/images/people.svg"
        />

        <Text style={{ x: leftMargin, y: 3, w: 2, h: 1, fontSize: 6 }}>
          *What percentage of users has reached the minimum amount of data to
          perform an analysis
        </Text>
        <Image
          src={{
            kind: "path",
            path: "https://corsproxy.io/?url=https://precure-cdn.azureedge.net/images/PRECURE MLI Back7.jpg",
          }}
          style={{ x: "65%", y: 1.5, h: "60%", w: "35%" }}
        />
        <Shape
          type="rect"
          style={{
            backgroundColor: precureGreen,
            borderColor: precureGreen,
            x: "20%",
            y: "95%",
            h: 0.02,
            w: "40%",
          }}
        />
      </Slide>
      <Slide style={{ backgroundColor: slideBackgroundColor }}>
        <Text
          style={{ x: leftMargin, y: 0.25, w: "50%", h: 0.3, fontSize: 20 }}
        >
          Results Per Activity
        </Text>
        <Shape
          type="rect"
          style={{
            backgroundColor: precureGreen,
            borderColor: precureGreen,
            x: leftMargin,
            y: 1,
            h: 0.02,
            w: "40%",
          }}
        />
        <Text
          style={{
            x: leftMargin,
            y: 1.2,
            w: "50%",
            h: "20%",
            fontSize: 11,
            verticalAlign: "top",
          }}
        >
          This Table presents the top 5 Activities ordered by Ergonomic Risk
          (MLI). Values highlighted in red indicate high risk, yellow indicates
          medium risk and green indicates low risk
        </Text>
        <Table
          style={{ x: leftMargin, y: 2, h: 2.5, w: 5 }}
          rows={GenerateErgonomicTable()}
        ></Table>
      </Slide>
      {activitySlides}

      {benchmarkSlides}
    </>
  );
};

type BaselineDataProps = {
  y: number;
  xMargin: number;
  src: string;
  title: string;
  value: string;
};
const BaselineData: React.FC<BaselineDataProps> = ({
  y,
  xMargin,
  src,
  title,
  value,
}) => {
  const precureGreen = "#5BBFAC";

  return (
    <>
      <Shape
        type="rect"
        style={{
          backgroundColor: precureGreen,
          borderColor: precureGreen,
          x: xMargin,
          y: y,
          h: 0.8,
          w: 2.5,
        }}
      />
      <Image
        style={{ h: 0.5, w: 0.5, x: xMargin + 0.2, y: y + 0.15 }}
        src={{
          kind: "path",
          path: src,
        }}
      />
      <Text
        style={{
          h: 0.8,
          w: 1.7,
          y: y,
          verticalAlign: "middle",
          x: xMargin + 0.7,
          fontSize: 11,
          color: "#FFFFFF",
          align: "center",
        }}
      >
        {title}
        {"\n"} {value}
      </Text>
    </>
  );
};
